<template>
  <div class="sound-doppler-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>f' = f · (v ± v_o) / (v ∓ v_s)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Background Grid -->
          <g stroke="rgba(255,255,255,0.02)" stroke-width="1">
            <line v-for="i in 10" :key="'gx'+i" :x1="i*40" y1="0" :x2="i*40" y2="240" />
            <line v-for="i in 6" :key="'gy'+i" x1="0" :y1="i*40" x2="400" :y2="i*40" />
          </g>

          <!-- Sound Waves -->
          <g v-for="w in waves" :key="w.id">
            <circle :cx="w.x" :cy="w.y" :r="w.r" fill="none" :stroke="colorScale(w)" stroke-width="1.5" opacity="0.6" />
          </g>

          <!-- The Source (Ambulance) -->
          <g :transform="`translate(${source.x}, ${source.y})`">
             <rect x="-15" y="-10" width="30" height="20" fill="#ff4757" rx="4" />
             <rect x="5" y="-8" width="8" height="16" fill="white" opacity="0.5" />
             <text x="0" y="5" text-anchor="middle" fill="white" font-size="20">🚑</text>
          </g>

          <!-- Observer -->
          <g transform="translate(350, 120)">
             <text x="0" y="0" font-size="20">🧍</text>
             <text x="-10" y="25" fill="#888" font-size="8">观察者</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>波长压缩：频率升高 (尖锐)</label>
              <div class="value">波长拉伸：频率降低 (低沉)</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>波源速度 v_s: {{ source.vx }}</label>
             <el-slider v-model="source.vx" :min="0" :max="5" step="0.5" size="mini"></el-slider>
          </div>
          <div class="row">
             <el-button type="primary" size="mini" @click="reset">重置位置</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当波源向观察者靠近时，由于波源在前一个波峰被发出后向前移动，后一个波峰会更早到达观察者，导致**视频率升高**；远离时则变低。这解释了救护车呼啸而过时声音由尖变浑的现象。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SoundDopplerViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      source: { x: 50, y: 120, vx: 2 },
      waves: [],
      waveCounter: 0,
      timer: null
    }
  },
  methods: {
    colorScale(w) {
       // Wave compression indicator
       return w.r < 50 ? '#00d2ff' : '#aaa';
    },
    reset() {
      this.source.x = 50;
      this.waves = [];
    },
    update() {
      // Move source
      this.source.x += this.source.vx;
      if (this.source.x > 400) this.source.x = -20;

      // Emit wave
      if (this.waveCounter % 20 === 0) {
        this.waves.push({
          id: Date.now(),
          x: this.source.x,
          y: this.source.y,
          r: 5
        });
      }
      this.waveCounter++;

      // Update waves
      this.waves.forEach(w => {
        w.r += 3; // Speed of sound constant
      });
      // Remove big waves
      this.waves = this.waves.filter(w => w.r < 400);

      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.sound-doppler-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
